import { createContext, useContext, useState } from 'react';
import api from '../api/axios';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(() => {
    const stored = localStorage.getItem('admin_user');
    return stored ? JSON.parse(stored) : null;
  });

  const login = async (email, password) => {
    const res = await api.post('/auth/admin/login', { email, password });
    const { token, admin: adminData } = res.data.data;
    localStorage.setItem('admin_token', token);
    localStorage.setItem('admin_user', JSON.stringify(adminData));
    setAdmin(adminData);
    return adminData;
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    setAdmin(null);
  };

  const updateUser = (updatedData) => {
    const updated = { ...admin, ...updatedData };
    localStorage.setItem('admin_user', JSON.stringify(updated));
    setAdmin(updated);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, updateUser, isAuthenticated: !!admin }}>
      {children}
    </AuthContext.Provider>
  );
};
